import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import LoginForm from './LoginForm'
import LoginLayout from '../../../components/LoginLayout';

class Login extends Component {
  static propTypes = {
    authenticate: PropTypes.func.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    redirectUri: PropTypes.string.isRequired,
  };

  state = {
    redirectToReferrer: false,
  };

  componentWillReceiveProps(nextProps) {
    // Redirect if we are logged in
    if (nextProps.loggedIn) {
      this.setState({ redirectToReferrer: true });
    }
  }

  render () {
    const { authenticate } = this.props;
    const { redirectToReferrer } = this.state;

    const matches = /(\?|&)from=([^&]+)/.exec(this.props.location.search);
    const queryPathname = matches && matches.length === 3 && matches[2];

    const { from } = this.props.location.state || { from: { pathname: (queryPathname || '/') } };

    if (redirectToReferrer) return <Redirect to={from} />;

    return (
      <LoginLayout title="Inloggen">
        <LoginForm onSubmit={values => authenticate(values)} />
      </LoginLayout>
    );
  }
}

export default Login;
